<script>
import VoucherPitch from '../components/VoucherPitch.vue'

export default {
    name: 'PurchaseVoucher',
    components: {
        VoucherPitch
    },
    methods: {
        onSuccess() {
            this.$router.push(this.getSuccessRoute())
        },
        getSuccessRoute() {
            if (this.$route.query.redirect) {
                return this.$route.query.redirect
            }

            return { name: 'reservations' }
        }
    },
    mounted() {
        
    }
}
</script>

<template>
    <b-container>
        <b-row>
            <b-col md="6" offset-md="3" class="mt-5 mb-5">
                <b-card class="mt-5" header="Kauf eines Geschenkgutscheins">
                    <voucher-pitch @done="onSuccess" />
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>
